    $(function () {
 $(".panel-leo").on("click", ".panel-header", function() {
     var next = $(this).next();
     next.slideToggle();
     $(".panel-body").not(next).slideUp();
   
 })
      });
// index-product-tab
    $(function () {
         $(".tab-item").on("click",function(){       
          $(this).addClass("active-des").siblings().removeClass("active-des");
          var desindex  = $(this).index();           
           $(".desc-main").eq(desindex).css({"opacity":"1","height":"auto"}).siblings().css({"opacity":"0","height":"0px"});         
          })
        });




// $(document).ready(function () {
//     $(window).on('scroll', function () {css()
//         var t = $(window).scrollTop();
//         if (t > 100) {      
//           $(".article__body-content").css("position","fixed") 
//         } else {
//              $(".article__body-content").css("position","") 
//         }
//     })
// });
// $(function(){
//     var navH = $(".article__body-content-div").offset().top;
//     $(window).scroll(function(){
//       var scroH = $(this).scrollTop();
//       if(navH-scroH<=180){
//         $(".article__body-content-div").css({"position":"fixed","top":150});
    
//       }else if(scroH<navH){
//         $(".article__body-content-div").css({"position":"static"});

//       }
//       if(scroH>=400){
//       $(".progress-container").show()   
//       }else(
//         $(".progress-container").hide()  
//       )
//     });
  

  
  
  
  

  
//    $(".article__body-content-a").click(function () {
//             $("body,html").animate({scrollTop: 0}, 100);
//         }); 
  
//   });

